"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConsoleAnalyticsHandler = void 0;
const react_1 = require("react");
function useConsoleAnalyticsHandler() {
    return (0, react_1.useMemo)(() => ({
        setUserId(userId) {
            console.debug('analytics.setUserId', userId);
        },
        trackEvent(event) {
            console.debug('analytics.trackEvent', event);
        },
        trackPage(data) {
            console.debug('analytics.trackPage', data);
        },
        updateProfile(update) {
            console.debug(update);
        },
    }), []);
}
exports.useConsoleAnalyticsHandler = useConsoleAnalyticsHandler;
//# sourceMappingURL=console.js.map